import script from "./ElderRay.vue?vue&type=script&lang=js"
export * from "./ElderRay.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__